/**
 * The ⓘ copy on each Create Invoice card (OR-1449).
 *
 * Almost every field on the form is pre-filled and locked, so these
 * sentences are the only thing telling the user where a value actually
 * comes from and where to go to change it. Taken verbatim from the Figma's
 * "Example - Tooltips" frame.
 *
 * ⚠️ Two exceptions, deliberate. The Figma's Premium & Fees and Commissions
 * tooltips end with "Edit here if needed." That sentence is dropped here
 * because those cards render read-only: the backend derives every one of
 * those amounts from `submission_quote` and the create request has no way
 * to carry an override, so inviting the user to edit them would be a
 * promise the app can't keep. Restore the full sentence the day the
 * backend accepts them.
 */
export const INVOICE_CARD_TOOLTIPS = {
    brokerage: "Auto-filled from brokerage records. Update on the UW Information page.",
    billingUser: "Auto-filled from broker records. Update on the UW Information page.",
    firstNamedInsured:
        "Auto-filled from the submission's FNI and primary location. Update on the UW Information and/or Schedule page.",
    invoiceDetails:
        "Auto-filled. Policy number updates on the Policy Details page; effective and expiration dates update on the UW Information page.",
    premiumAndFees: "Auto-filled from Premium Selection page.",
    commissions: "Auto-filled from Premium Selection page.",
} as const;
